<h2>{{ "Withdraw Funds" | translate }}</h2>
<form [formGroup]="form" (submit)="handleSubmit()">
  <mat-form-field appearance="outline" color="primary">
    <mat-label>{{ "Amount" | translate }}</mat-label>
    <input
      formControlName="AMOUNT"
      placeholder="Amount"
      matInput
      required=""
      type="number"
    />
    @if (form.controls["AMOUNT"].hasError("required")) {
    <mat-error>{{ "Amount is required" | translate }}</mat-error>
    }
  </mat-form-field>
  <mat-form-field appearance="outline" color="primary">
    <mat-label>{{ "Description" | translate }}</mat-label>
    <textarea
      formControlName="DESCRIPTION"
      matInput
      placeholder="Description"
    ></textarea>
  </mat-form-field>
  <mat-form-field appearance="outline" color="primary">
    <mat-label>{{ "Password" | translate }}</mat-label>
    <input
      formControlName="PASSWORD"
      placeholder="Password"
      matInput
      required=""
      type="password"
    />
    @if (form.controls["PASSWORD"].hasError("required")) {
    <mat-error>{{ "Password is required" | translate }}</mat-error>
    }
  </mat-form-field>
  <div class="actions">
    <button (click)="bottomSheetRef.dismiss()" type="button" mat-stroked-button>
      {{ "Cancel" | translate }}
    </button>
    <button type="submit" mat-flat-button color="primary">
      {{ "Submit" | translate }}
    </button>
  </div>
</form>
